import React from 'react';
import styled from 'styled-components';
import { MQ } from '../../../style/MediaQueryHelpers';
import BookDemoButton from '../../BookDemoButton';
import { LinkPaths } from '../../Constants';
import { ListPricingPlatformFeeFromValue } from '../../pricing/data/LitePricingConstants';

const Wrapper = styled.div`
	margin-top: 40px;
	max-width: 300px;
	width: 90%;
	margin-left: auto;
	margin-right: auto;
	padding-top: 10px;
	padding-bottom: 10px;
	border-top: 1px solid #00a896;
	border-bottom: 1px solid #00a896;

	${MQ.W640} {
		max-width: 90%;
		margin-top: 10px;
	}
`;

const ACAL = styled.h2`
	color: #00a896;
	font-size: 24px;
`;

const PriceText = styled.div`
	margin: 5px 0;
	font-weight: bold;
`;

const PriceNumber = styled.span`
	font-size: 20px;
`;

const PriceSmallPrint = styled.div`
	margin-bottom: 15px;
`;

type LiteAdvertProps = {
	userPrice?: number;
};

const LiteAdvert: React.FC<LiteAdvertProps> = (props) => {
	return (
		<Wrapper>
			<div>Now supported on</div>
			<ACAL>Cloud Archive Lite</ACAL>
			<div>A secure cloud archive for small and medium sized businesses.</div>
			{props.userPrice ? (
				<>
					<PriceText>
						From <PriceNumber>${props.userPrice}</PriceNumber> / user / month
					</PriceText>
					<PriceSmallPrint>+ platform fee</PriceSmallPrint>
				</>
			) : (
				<PriceText>
					Platform from <PriceNumber>${ListPricingPlatformFeeFromValue}</PriceNumber> / month
				</PriceText>
			)}
			<BookDemoButton
				isForMobile={false}
				isBordered={true}
				textOverride={"SEE WHAT'S INCLUDED"}
				linkOverride={LinkPaths.LITE_PRODUCT}
			/>
		</Wrapper>
	);
};

export default LiteAdvert;
